import React from 'react'
import {Spinner} from 'react-bootstrap';

export default function Spiner(){
    return (
        <div className="spinner__style">
            <Spinner animation="border"/>
        </div>
    )
}
